// Scroll To Top
document.querySelector('.js-scroll-to-top').addEventListener('click', function(event) {
    event.preventDefault();

    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
});

$(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
        $('.header').addClass('header--scrolled');
    }
    else {
        $('.header').removeClass('header--scrolled');
    }
});
